/** Filtra items de microcatálogo por nombre o código, sin distinguir mayúsculas. */
export default function filtrarItems(items, texto) {
    const q = texto.trim().toLowerCase();
    if (!q) return items;
    return items.filter(
        (item) =>
            item.nombre?.toLowerCase().includes(q) ||
            item.codigo?.toString().toLowerCase().includes(q)
    );
}
